import React from 'react'
import { storiesOf } from '@storybook/react'

import Paper from 'components/Paper'
import GeneralListItem from 'components/GeneralListItem'

import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List'

storiesOf('GeneralListItem', module)
  .add('default', () => (
    <List>
      <GeneralListItem headline="Headline only" />
      <GeneralListItem headline="Headline" subtitle="with subtitle" />
      <GeneralListItem
        headline="Headline (custom variant)"
        headlineVariant="caption"
        subtitle="with subtitle (custom variant)"
        subtitleVariant="h3"
      />
      <GeneralListItem
        headline="Headline"
        subtitle="with subtitle"
        leftChild="Left child"
        rightChild="Right child"
      />
      <GeneralListItem
        headline="Headline"
        subtitle="with subtitle"
        leftChild="Left child"
        rightChild="Right child"
        dropdownChild={<Paper color="accent">Inactive dropdown</Paper>}
      />
      <GeneralListItem
        headline="Headline"
        subtitle="with subtitle"
        leftChild="Left child"
        rightChild="Right child"
        isDropdownActive
        dropdownChild={<Paper color="accent">Active dropdown</Paper>}
      />
      <GeneralListItem
        button
        xs={6}
        headline="Headline"
        subtitle="with subtitle"
        leftChild="Left child"
      >
        <Grid item xs={3}>
          Grid with fixed basis
        </Grid>
        <Grid item xs={3} container justify="flex-end">
          <Grid item>
            Grid aligned right
          </Grid>
        </Grid>
      </GeneralListItem>
    </List>
  ))
